(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["browse-by-category-powerbox"] && !window.DesignMode) return;
  try {
    

// let activeItemIndex = 0;
// const maxWidth = '(max-width: 990px)';
// const itemsBrowseCategory = document.getElementById('categories-pwb');
// const itemsBrowseCategoryDivs = itemsBrowseCategory.querySelectorAll('[id^="item-browse-by-category-pwb-"]');
// const buttonItemSubcategory = document.querySelectorAll('[data-labelbuttonredirect="button-subcategory-pwb"]');
// const itemsBrowseCategoryMobile = itemsBrowseCategory.querySelectorAll('[id^="item-mobile-browse-by-category-pwb-"]');
// const itemBrowseCategorySelectedMobile = itemsBrowseCategory.querySelector(
//   '[id="item-mobile-browse-by-category-pwb-0"]'
// );
// const subcategoriesSelector = document.querySelectorAll(`[data-indexcategory]`);
// const isMobile = window.matchMedia(maxWidth);

// // Function to handle category view based on screen width
// function changeCategoryActiveView(isMobile) {
//   const mobileCategory = document.querySelector(`[id="item-mobile-browse-by-category-pwb-${activeItemIndex}"]`);
//   const desktopCategories = document.querySelector('.items-desktop').querySelectorAll(`a[data-indexcategory="${activeItemIndex}"]`);
//   if (isMobile.matches) {
//     // Hide all mobile categories initially
//     itemsBrowseCategoryMobile.forEach(itemMobile => itemMobile.style.display = 'none');

//     // Show the selected mobile category
//     mobileCategory.style.display = 'flex';

//     // Hide all desktop categories for mobile view
//     desktopCategories.forEach((element) => {
//       element.style.display = 'none';
//     });
//   } else {
//     // On desktop view, show the categories normally
//     mobileCategory.style.display = 'none';
//     desktopCategories.forEach((element) => {
//       element.style.display = 'flex';
//     });
//   }
// }

// // Event listener for screen width change
// isMobile.addEventListener('change', function () {
//   changeCategoryActiveView(isMobile);
// });

// // Initialize the display based on screen size
// for (let subcategory of subcategoriesSelector) {
//   subcategory.style.display = 'none';
// }

// for (let itemMobile of itemsBrowseCategoryMobile) {
//   itemMobile.style.display = 'none';
// }

// if (isMobile.matches) {
//   itemBrowseCategorySelectedMobile.style.display = 'flex';
// }

// // Show initial active category and set click event listeners
// itemsBrowseCategoryDivs.forEach((element, index) => {
//   showItemSelected(activeItemIndex, index, element);
//   element.addEventListener('click', showCategory);
// });

// // Toggle category on click
// function showCategory(event) {
//   const categorySelectedIndex = parseInt(this.id.split('-').at(-1));

//   // Check if the clicked tab is already active
//   if (categorySelectedIndex === activeItemIndex && isMobile.matches) {
//     // If the active tab is clicked again, close it (hide its content)
//     closeAllCategories();
//     // Remove active class and add inactive class for the closed tab
//     updateTabClasses(categorySelectedIndex);
//     activeItemIndex = -1; // Reset active index to "no active category"
//   } else {
//     activeItemIndex = categorySelectedIndex;
//     // Close all other categories (subcategories and mobile)
//     closeAllCategories();

//     // Show the selected category for the active tab
//     if (isMobile.matches) {
//       itemsBrowseCategory.querySelector(
//         `[id="item-mobile-browse-by-category-pwb-${categorySelectedIndex}"]`
//       ).style.display = 'flex';
//       if (event.isTrusted) {
//         setTimeout(() => {
//           const topOffset = this.getBoundingClientRect().top + window.scrollY - 75;
//           window.scrollTo({ top: topOffset, behavior: 'smooth' });
//            }, 150);
//       }
      
//     }

//     // Update visual styles for the selected category
//     itemsBrowseCategoryDivs.forEach((element, index) => {
//       showItemSelected(categorySelectedIndex, index, element);
//     });
//   }
// }

// // Close all categories
// function closeAllCategories() {
//   // Hide all subcategories and mobile items
//   for (let subcategory of subcategoriesSelector) {
//     subcategory.style.display = 'none';
//   }

//   for (let itemMobile of itemsBrowseCategoryMobile) {
//     itemMobile.style.display = 'none';
//   }
// }

// // Function to display selected category's details and subcategories
// function showItemSelected(categorySelectedIndex, index, element) {
//   const description = element.querySelector('p');
//   const title = element.querySelector('span');
//   const categoryUrl = title.dataset['categoryurl'];
//   const subcategorySelected = document.querySelectorAll(`a[data-indexcategory="${categorySelectedIndex}"]`);

//   if (categorySelectedIndex === index) {
//     description.style.display = 'block';

//     // Show and set hover effect for subcategories
//     for (let subcategory of subcategorySelected) {
//       subcategory.style.display = 'flex';
//       subcategory.addEventListener('mouseover', () => {
//         subcategory.classList.add('pbx-shadow-md');
//       });
//       subcategory.addEventListener('mouseout', () => {
//         subcategory.classList.remove('pbx-shadow-md');
//       });
//     }

//     // Update button subcategory labels and links
//     buttonItemSubcategory.forEach((element) => {
//       const buttonSpan = element.querySelector('span');
//       buttonSpan.innerHTML = title.innerHTML;
//       element.href = categoryUrl;
//     });

//     // Add active class for selected category
//     title.classList.add('active-item-browse-category');
//     title.classList.remove('inactive-item-browse-category');
//     element.classList.add('active-border-browse-category-active');
//     element.classList.remove('inactive-border-browse-category-active');
//   } else {
//     description.style.display = 'none';
//     title.classList.add('inactive-item-browse-category');
//     title.classList.remove('active-item-browse-category');
//     element.classList.remove('active-border-browse-category-active');
//     element.classList.add('inactive-border-browse-category-active');
//   }
// }

// // Function to update tab classes when a tab is closed (for mobile view)
// function updateTabClasses(categorySelectedIndex) {
//   const element = itemsBrowseCategoryDivs[categorySelectedIndex];
//   const title = element.querySelector('span');
//   const description = element.querySelector('p');

//   // Remove active class and add inactive class for the closed tab
//   title.classList.add('inactive-item-browse-category');
//   title.classList.remove('active-item-browse-category');
//   element.classList.remove('active-border-browse-category-active');
//   element.classList.add('inactive-border-browse-category-active');
  
//   description.style.display = 'none';
// }

// // Automatic click for the first element (optional)
// document.addEventListener('DOMContentLoaded', function() {
//   var click_first = document.querySelectorAll(".item-browse-by-category-pwb.custom-order-click");

//   for (var i = 0; i < click_first.length; i++) {
//     click_first[i].addEventListener('click', function() {
//       console.log('Element clicked!');
//     });

//     // Simulate a click on the current element
//     click_first[i].click();  // Simulate click on the current element
//   }
// });


let activeItemIndex = 0;
const maxWidth = '(max-width: 990px)';
const itemsBrowseCategory = document.getElementById('categories-pwb');
const itemsBrowseCategoryDivs = itemsBrowseCategory.querySelectorAll('[id^="item-browse-by-category-pwb-"]');
const buttonItemSubcategory = document.querySelectorAll('[data-labelbuttonredirect="button-subcategory-pwb"]');
const itemsBrowseCategoryMobile = itemsBrowseCategory.querySelectorAll('[id^="item-mobile-browse-by-category-pwb-"]');
const itemBrowseCategorySelectedMobile = document.querySelector('[id="item-mobile-browse-by-category-pwb-0"]');
const subcategoriesSelector = document.querySelectorAll('[data-indexcategory]');
const isMobile = window.matchMedia(maxWidth);

// --- Handle category view toggle based on screen size
function changeCategoryActiveView(mediaQuery) {
  const mobileCategory = document.querySelector(`[id="item-mobile-browse-by-category-pwb-${activeItemIndex}"]`);
  const desktopCategories = document.querySelectorAll(`.items-desktop a[data-indexcategory="${activeItemIndex}"]`);

  if (mediaQuery.matches) {
    itemsBrowseCategoryMobile.forEach(item => item.style.display = 'none');
    if (mobileCategory) mobileCategory.style.display = 'flex';
    desktopCategories.forEach(el => el.style.display = 'none');
  } else {
    if (mobileCategory) mobileCategory.style.display = 'none';
    desktopCategories.forEach(el => el.style.display = 'flex');
  }
}

// --- Setup media query listener (with iOS compatibility)
if (typeof isMobile.addEventListener === 'function') {
  isMobile.addEventListener('change', () => changeCategoryActiveView(isMobile));
} else if (typeof isMobile.addListener === 'function') {
  isMobile.addListener(() => changeCategoryActiveView(isMobile));
}

// --- Hide all on initial load
subcategoriesSelector.forEach(sub => sub.style.display = 'none');
itemsBrowseCategoryMobile.forEach(item => item.style.display = 'none');
if (isMobile.matches && itemBrowseCategorySelectedMobile) {
  itemBrowseCategorySelectedMobile.style.display = 'flex';
}

// --- Show initial category and bind click
itemsBrowseCategoryDivs.forEach((element, index) => {
  showItemSelected(activeItemIndex, index, element);
  element.addEventListener('click', showCategory);
});

function showCategory(event) {
  const categorySelectedIndex = parseInt(this.id.split('-').pop(), 10);

  if (categorySelectedIndex === activeItemIndex && isMobile.matches) {
    closeAllCategories();
    updateTabClasses(categorySelectedIndex);
    activeItemIndex = -1;
  } else {
    activeItemIndex = categorySelectedIndex;
    closeAllCategories();

    if (isMobile.matches) {
      const mobileItem = itemsBrowseCategory.querySelector(`[id="item-mobile-browse-by-category-pwb-${categorySelectedIndex}"]`);
      if (mobileItem) mobileItem.style.display = 'flex';

      // Smooth scroll fallback
      if (event.isTrusted) {
        setTimeout(() => {
          const offsetTop = this.getBoundingClientRect().top + window.scrollY - 75;
          if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({ top: offsetTop, behavior: 'smooth' });
          } else {
            window.scrollTo(0, offsetTop);
          }
        }, 150);
      }
    }

    itemsBrowseCategoryDivs.forEach((el, idx) => {
      showItemSelected(categorySelectedIndex, idx, el);
    });
  }
}

function closeAllCategories() {
  subcategoriesSelector.forEach(sub => sub.style.display = 'none');
  itemsBrowseCategoryMobile.forEach(item => item.style.display = 'none');
}

function showItemSelected(categoryIndex, index, element) {
  const description = element.querySelector('p');
  const title = element.querySelector('span');
  const categoryUrl = title.dataset['categoryurl'];
  const subcategoryItems = document.querySelectorAll(`a[data-indexcategory="${categoryIndex}"]`);

  if (categoryIndex === index) {
    if (description) description.style.display = 'block';

    subcategoryItems.forEach(sub => {
      sub.style.display = 'flex';
      sub.addEventListener('mouseover', () => sub.classList.add('pbx-shadow-md'));
      sub.addEventListener('mouseout', () => sub.classList.remove('pbx-shadow-md'));
    });

    buttonItemSubcategory.forEach(button => {
      const span = button.querySelector('span');
      if (span) span.innerHTML = title.innerHTML;
      button.href = categoryUrl;
    });

    title.classList.add('active-item-browse-category');
    title.classList.remove('inactive-item-browse-category');
    element.classList.add('active-border-browse-category-active');
    element.classList.remove('inactive-border-browse-category-active');
  } else {
    if (description) description.style.display = 'none';
    title.classList.add('inactive-item-browse-category');
    title.classList.remove('active-item-browse-category');
    element.classList.remove('active-border-browse-category-active');
    element.classList.add('inactive-border-browse-category-active');
  }
}

function updateTabClasses(categoryIndex) {
  const element = itemsBrowseCategoryDivs[categoryIndex];
  const title = element.querySelector('span');
  const description = element.querySelector('p');

  title.classList.add('inactive-item-browse-category');
  title.classList.remove('active-item-browse-category');
  element.classList.remove('active-border-browse-category-active');
  element.classList.add('inactive-border-browse-category-active');

  if (description) description.style.display = 'none';
}

// --- Optional auto-click for elements with .custom-order-click
document.addEventListener('DOMContentLoaded', () => {
  const clickables = document.querySelectorAll('.item-browse-by-category-pwb.custom-order-click');
  clickables.forEach(el => {
    el.addEventListener('click', () => console.log('Element clicked!'));
    el.click(); // simulate click
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-powerbox"] && !window.DesignMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-text-buttons"] && !window.DesignMode) return;
  try {
    
  const imgTextCarousel = document.querySelectorAll('.imgs-carousel');
  if (imgTextCarousel && imgTextCarousel[0]) {
    imgTextCarousel[0].style.display = 'block';
  }

  let slidePosition = -1;

  setInterval(function () {
    slidePosition++;
    imgTextCarousel.forEach((element, index) => {
      if (index !== slidePosition) {
        element.style.display = 'none';
      } else {
        element.style.display = 'block';
      }
    });
    if (slidePosition === imgTextCarousel.length - 1) {
      slidePosition = 0;
    }
  }, 3000);

  } catch(e) { console.error(e); }
})();
})();
